import { render, staticRenderFns } from "./DatasetEditors.vue?vue&type=template&id=e063f9ee&"
import script from "./DatasetEditors.vue?vue&type=script&lang=js&"
export * from "./DatasetEditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports